import React from 'react';
import Text from '../animation/Text';
import { ModuleSectionPropsModel } from '@/types';
import HeadingTag from './HeadingTag';
import Stack from '../animation/Stack';
import classNames from 'classnames';
import { fadeIn } from '@/animations';

interface ISectionHeadingProps extends React.HTMLAttributes<HTMLDivElement> {
  data: ModuleSectionPropsModel;
}

const SectionHeading = ({ data, className, ...props }: ISectionHeadingProps) => {
  const { headingTag } = data;
  return (
    <Stack className={classNames('section-heading flex flex-col gap-3', className)} {...props}>
      <HeadingTag className="heading" animation={fadeIn} tag={headingTag} heading={data.heading} />
      {data.summary && (
        <Text animation={fadeIn} className="summary body-1" dangerouslySetInnerHTML={{ __html: data.summary }} />
      )}
    </Stack>
  );
};

export default SectionHeading;
